/**
 *
 * AppVersionInformation
 *
 */

import React, { memo, useCallback, useEffect, useState } from "react";
import classNames from "classnames";
// styles
import "./style.scss";

import {
  appHelper,
  // update
  appUpdate,
} from "appCapacitor/helpers";

// utils
import useDeviceDetect from "utils/useDeviceDetect";
import { APP_VERSION } from "utils/constants";

// context
import { withUser } from "engine/Contexts/User.context";

function AppVersionInformation({
  authenticated,
  loading,
  user,
  label,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames(
    "app-version-information",
    !!label && "has-label",
    className,
  );

  const { isAuthenticated } = user;

  const isAuthed = isAuthenticated();
  const [appVersion, setAppVersion] = useState(APP_VERSION);
  const [appNewVersion, setAppNewVersion] = useState(false);

  const { isMobile } = useDeviceDetect();
  let width = window.innerWidth > 0 ? window.innerWidth : screen.width;
  let isApp = false;
  if (!appHelper.isWeb || isMobile || width < 800) {
    isApp = true;
  }

  const checkAppVersion = async () => {
    const appIn = await appHelper.appInfo();
    const { id, build, version } = appIn;
    try {
      const bundle = await appUpdate.getAppVersion();
      const {
        version: currentVersion,
        build: currentBuild,
        newVersion,
        newBuild,
      } = bundle;
      if (!!currentVersion && !!currentBuild) {
        setAppVersion(currentVersion);
        if (Number(currentBuild) < Number(newBuild)) {
          setAppNewVersion(newVersion);
        }
      } else {
        setAppVersion(version);
      }
    } catch (err) {
      setAppVersion(version);
    }
  };

  useEffect(() => {
    if (!appHelper.isWeb && isApp) {
      checkAppVersion();
    } else if (!isApp) {
      setAppVersion(APP_VERSION);
    }
  }, []);

  useEffect(() => {
    if ((!loading && !!authenticated) || (!loading && !!isAuthed)) {
      if (!appHelper.isWeb && isApp) {
        checkAppVersion();
      } else if (!isApp) {
        setAppVersion(APP_VERSION);
      }
    }
  }, [isAuthed, authenticated, loading]);

  const checkUpdates = useCallback(async () => {
    // INFO: Enable update app from bundle.zip only for development and for staging version of app.
    // INFO: For production will work App Store and Apple Store!
    if (
      process.env.BASE_ENV == "development" ||
      process.env.BASE_ENV == "local"
    ) {
      !appHelper.isWeb && (await appUpdate.checkAndUpdateApp());
    }
  }, [isApp, appHelper.isWeb]);

  return (
    <div className={childClassNames}>
      {!appHelper.isWeb &&
        !!appVersion &&
        (process.env.BASE_ENV == "development" ||
          process.env.BASE_ENV == "local") && (
          <span className="appUpdates" onClick={checkUpdates}>
            {`Check on Updates ${
              !!appNewVersion ? `(available: ${appNewVersion})` : ""
            }`}
          </span>
        )}
      {!!appVersion && (
        <span className="appVersion">
          {!!label && label} {appVersion}
        </span>
      )}
    </div>
  );
}

AppVersionInformation.defaultProps = {
  authenticated: false,
  loading: false,
  label: "",
};
AppVersionInformation.propTypes = {};

export default withUser(AppVersionInformation);
